import { CheckIcon, ImageCircle, cn } from '$components'
import { User } from '$api-client/types.gen'

export type PersonSelectListProps = {
  options: User[]
  selectedPeopleIds: number[]
  onSelectPerson: (person: User) => void
  onClear: () => void
  className?: string
}

export function PersonSelectList({
  options,
  selectedPeopleIds,
  onSelectPerson,
  onClear,
  className,
}: PersonSelectListProps) {
  return (
    <div className={cn('flex flex-col bg-surface text-body-sm overflow-y-auto', className)}>
      <button
        type="button"
        onClick={onClear}
        className="w-full text-left py-stack-tight px-stack text-fg-muted hover:bg-bg-subtle/50 [&:not(:last-child)]:border-b border-border"
      >
        All
      </button>

      {options.map((person, key) => (
        <button
          key={key}
          type="button"
          onClick={() => onSelectPerson(person)}
          className={cn(
            'flex text-left py-stack-tight px-stack hover:bg-bg-subtle/50 text-fg-muted items-center gap-stack-tight',
            'relative',
          )}
        >
          <span className="absolute top-1/2 -translate-y-1/2 right-2">
            {selectedPeopleIds.includes(person.id) && (
              <CheckIcon className="size-4 text-brand-hover" />
            )}
          </span>

          <ImageCircle
            size="sm"
            image={person.image}
          />

          <span className="truncate mr-stack-roomy">
            {person.first_name + ' ' + person.last_name}
          </span>
        </button>
      ))}
    </div>
  )
}
